import {
  DirectDealSliderFilterKeyType,
  directDealFilterSliderConstant,
  directDealSliderTicks,
} from '../../constants/filter/slider/directDealFilterSliderConstant';
import { formatPrice } from '../formatter/formatPrice.util';

// 슬라이더 위치를 실제 값으로 바꾼다. 양 끝 칸(제한 없음)은 undefined를 돌려준다.
export const getDirectDealSliderValue = (
  key: DirectDealSliderFilterKeyType,
  sliderIndex: number,
): number | undefined => {
  return directDealSliderTicks[key][sliderIndex - 1];
};

// 실제 값을 슬라이더 위치로 바꾼다. 눈금에 없는 값은 undefined를 돌려준다.
export const getDirectDealSliderIndex = (key: DirectDealSliderFilterKeyType, value: number): number | undefined => {
  const tickIndex = directDealSliderTicks[key].indexOf(value);

  return tickIndex === -1 ? undefined : tickIndex + 1;
};

const formatSliderValue = (key: DirectDealSliderFilterKeyType, value: number): string => {
  if (key === 'price') {
    return formatPrice(value);
  }

  // 연식에는 천 단위 구분 기호를 넣지 않는다.
  if (key === 'manufacturedYear') {
    return String(value);
  }

  return value.toLocaleString();
};

// 선택 범위를 '150~250마력', '2017년식 이상', '2억원 이하', '전체'처럼 표시한다.
export const formatDirectDealSliderRangeText = (
  key: DirectDealSliderFilterKeyType,
  sliderIndexes: number[],
): string => {
  const { prefix } = directDealFilterSliderConstant[key];

  const minValue = getDirectDealSliderValue(key, sliderIndexes[0]);
  const maxValue = getDirectDealSliderValue(key, sliderIndexes[1]);

  if (minValue === undefined && maxValue === undefined) {
    return '전체';
  }

  if (minValue === undefined) {
    return `${formatSliderValue(key, maxValue as number)}${prefix} 이하`;
  }

  if (maxValue === undefined) {
    return `${formatSliderValue(key, minValue)}${prefix} 이상`;
  }

  // 가격은 '1,000만원~2억원'처럼 양쪽에 단위를 붙이고, 나머지는 단위를 뒤에 한 번만 붙인다.
  if (key === 'price') {
    return `${formatSliderValue(key, minValue)}${prefix}~${formatSliderValue(key, maxValue)}${prefix}`;
  }

  return `${formatSliderValue(key, minValue)}~${formatSliderValue(key, maxValue)}${prefix}`;
};
